<template>
  <b-modal
      id="modalPreview"
      modal-class="dialog-1000"
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      scrollable
    >
    <template #modal-title>
        <h3>Previsualización de encuesta {{ data.id }}</h3>
    </template>
    <div v-show="loading" class="center-spinner mb-3 mt-3">
        <b-spinner />
    </div>
    <div v-show="!loading">
      <small>Nota: las respuestas seleccionadas en la vista previa no serán guardadas.</small>
      <pop-up-survey :surveyId="data.id" @showPreviewSurvey="showPreviewSurvey" class="mt-1"/>
    </div>
  </b-modal>
</template>
<script>
import PopUpSurvey from '../components/PopUpSurvey.vue'
export default {
  components: {PopUpSurvey},
  props: ['data'],
  data () {
    return {
      loading: true
    }
  }, 
  watch: {
    data () {
      this.loading = true
    }
  },
  methods: {
    showPreviewSurvey () {
      this.loading = false
    }
  }
}
</script>